'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RadioSelect(props) {
  var name = props.name,
      value = props.value,
      options = props.options,
      onChange = props.onChange,
      inputRef = props.inputRef,
      disabled = props.disabled;

  // TODO process isInvalid prop

  return _react2.default.createElement(
    'span',
    null,
    options.map(function (option, index) {
      return _react2.default.createElement(
        'label',
        { key: option.label, style: { marginRight: 20 } },
        _react2.default.createElement('input', {
          ref: index === 0 ? inputRef : null,
          type: 'radio',
          name: name,
          value: option.value,
          checked: value === option.value,
          onChange: onChange,
          disabled: disabled
        }),
        option.label
      );
    })
  );
}

RadioSelect.propTypes = {
  name: _propTypes.string.isRequired,
  value: _propTypes.any,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.any.isRequired,
    label: _propTypes.string.isRequired
  })).isRequired,
  disabled: _propTypes.bool,
  onChange: _propTypes.func.isRequired,
  inputRef: _propTypes.func
};

exports.default = RadioSelect;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/RadioSelect/RadioSelect.js
// module id = 1775
// module chunks = 0